import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import { installGlobalErrorReporting, reportClientError } from "./lib/errorReporting";
import { installOnboardingRecovery } from "./lib/onboardingRecovery";
import { installPwaExperience } from "./lib/pwaExperience";
import { installPwaIosButtonFix } from "./lib/pwaIosButtonFix";
import { prepareInstalledPwaStartup } from "./lib/pwaRecovery";
import { installFamBucksEnhancements } from "./lib/famBucksEnhancements";
import "./styles.css";
import "./investment-holdings-density.css";
import "./home-hunt-static.css";
import "./house-task-polish.css";
import "./house-task-grid.css";

installGlobalErrorReporting();
prepareInstalledPwaStartup();
installPwaExperience();
installPwaIosButtonFix();
installOnboardingRecovery();
installFamBucksEnhancements();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/firebase-messaging-sw.js").catch((error) => {
      reportClientError(error, "service-worker");
    });
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>
);

